<template>
  <div class="pros-DTD-container">
    <div class="pros-DTD-badge">{{ DTD.badge }}</div>
    <div class="pros-DTD-title">{{ DTD.title }}</div>
    <div class="pros-DTD-description">
      {{ DTD.description }}
    </div>
    <div class="row">
      <div class="col-lg-7 col-12">
        <div class="row">
          <div
            v-for="(block, b) in DTD.blocks"
            :key="b"
            class="col-lg-6 col-12 pros-DTD-block"
          >
            <div class="pros-DTD-block-title">{{ block.title }}</div>
            <div class="pros-DTD-block-desc">{{ block.desc }}</div>
          </div>
        </div>
      </div>
      <div class="col-lg-5 col-12">
        <div class="row">
          <div v-for="(img, i) in DTD.images" :key="i" class="col-lg-6 col-12">
            <img :src="img" class="pros-DTD-img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper/core";
import { mapGetters } from "vuex";

SwiperCore.use([Autoplay, Pagination, Navigation]);

export default {
  name: "parentsSolution",
  components: {},
  props: ["DTD"],
  computed: {
    ...mapGetters(["getTestimonials", "getIndividualSolutions"]),
  },
  data() {
    return {
      panel: [0],
    };
  },
};
</script>

<style></style>
